import { render, staticRenderFns } from "./feedTypeNav.vue?vue&type=template&id=a55f194a"
import script from "./feedTypeNav.vue?vue&type=script&lang=js"
export * from "./feedTypeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports